const topics = [
  { tag: '斗破苍穹', heat: '9.8万讨论' },
  { tag: '鬼灭之刃', heat: '8.6万讨论' },
  { tag: '我独自升级', heat: '7.2万讨论' },
  { tag: '下拉式阅读', heat: '6.5万讨论' },
  { tag: '国漫崛起', heat: '5.8万讨论' },
  { tag: '完美世界', heat: '5.3万讨论' },
  { tag: '咒术回战', heat: '4.9万讨论' },
  { tag: '免费漫画', heat: '4.6万讨论' },
  { tag: '新番推荐', heat: '4.1万讨论' },
];

const heatColors = [
  'text-primary-500 bg-primary-100',
  'text-primary-500 bg-primary-100',
  'text-accent-500 bg-accent-100',
  'text-secondary-500 bg-secondary-100',
  'text-secondary-500 bg-secondary-100',
  'text-secondary-500 bg-secondary-100',
  'text-secondary-500 bg-secondary-100',
  'text-secondary-500 bg-secondary-100',
  'text-secondary-500 bg-secondary-100',
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            漫画圈最火热的话题讨论，看看大家都在关注什么
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <a
              key={topic.tag}
              href="#"
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer no-underline ${heatColors[idx]}`}
            >
              {idx < 3 && <i className="ri-fire-line text-sm"></i>}
              <span>{topic.tag}</span>
              <span className="text-xs opacity-70">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}